import React from "react";
import mitch from './imgs/mitch.jpg';
import maisha from './imgs/maisha.jpg';
import nate from './imgs/nate.jpg';

class AboutUs extends React.Component {
    render() {
        return (
            <section className="bg-gray-400 mx-auto w-4/5 rounded-xl mb-24" id="AboutUs">
                <section className="container mx-auto px-6 p-5" >
                    <h2 className="text-5xl font-bold text-center text-gray-800 mb-8">
                        Our Coaches
                    </h2>                    
                    <div className="flex items-center flex-wrap">
                        <div className="w-full md:w-1/2">
                            <img className="rounded-lg" src={maisha} alt="Lorem" />
                        </div>
                        <div className="w-full md:w-1/2 pl-0 md:pl-10 ">
                            <h4 className="text-4xl text-gray-800 font-bold mb-3 pt-5">Meet Maisha!</h4>
                            <p className="text-2xl text-gray-600 mb-8 ">
                                Maisha has been a certified personal trainer for over 14 years! She uses her extensive experience to address any pain, imbalance, goal you may have!
                                She believes in a balanced lifestyle approach to fitness to get you to your goals efficiently, and to last a lifetime!
                                She is a certified Fascial Stretch Therapy Practitioner, this allows her to work with clients with injuries/aches/ pain!
                                Whether your goal is weight loss, muscle gain, pre/post-natal, reducing pain/stiffness, Maisha is experienced at it all!
                                <br />
                                <br />
                                Certifications:
                                <ul className="list-disc pl-10">
                                    <li>CPTN - Certified Personal Trainer</li>
                                    <li>Stretch To Win - Fascial Stretch Therapist</li>
                                    <li>Myofascial Cupping Practitioner - FMT</li>
                                    <li>Progressive Olympic Lifting Hybrid Level 1</li>
                                    <li>Fitness Kickboxing - FKCI Level 1</li>
                                    <li>Adaptive Fitness Specialist </li>
                                    <li>TRX Suspension Training Specialist</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </section>
            </section>
        );
    }
};
export default AboutUs;
